import { z } from "zod";

export const ErpEntitySchema = z.object({
  id: z.string(),
  name: z.string(),
  shouldSyncBillAutomatically: z.boolean(),
  shouldSyncBillPaymentAutomatically: z.boolean(),
  glBillPayableAccount: z
    .object({
      id: z.string(),
      name: z.string(),
      generalLedgerAccountNumber: z.string(),
    })
    .nullable(),
  glFundingAccount: z
    .object({
      id: z.string(),
      name: z.string(),
      generalLedgerAccountNumber: z.string(),
    })
    .nullable(),
  glClearingAccount: z
    .object({
      id: z.string(),
      name: z.string(),
      generalLedgerAccountNumber: z.string(),
    })
    .nullable(),
  emailShortName: z.string().nullable(),
});

export type ErpEntity = z.infer<typeof ErpEntitySchema>;
